import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Imgsec3 = () => {
  return (
    <section className="image-grid-section ">
      <Container>
        <Row className="justify-content-center">
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital21).jpg" 
              alt="Transport Service 10"
              className="img-fluid rounded shadow mx-auto d-block"
              width="304"
              height="700"
            />
          </Col>
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital22).png"
              alt="Transport Service 2"
              className="img-fluid rounded shadow mx-auto d-block"
              width="304"
              height="700"
            />
          </Col>
          {/* <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital15).png"
              alt="Transport Service 3"
              className="img-fluid rounded shadow mx-auto d-block"
            />
          </Col> */}
          {/* <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital16).png"
              alt="Transport Service 4"
              className="img-fluid rounded shadow mx-auto d-block"
            />
          </Col> */}
        </Row>
        {/* <Row className="justify-content-center">
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital17).png" 
              alt="Transport Service 10"
              className="img-fluid rounded shadow mx-auto d-block"
            />
          </Col>
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital18).png"
              alt="Transport Service 2"
              className="img-fluid rounded shadow mx-auto d-block"
            />
          </Col>
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital19).png"
              alt="Transport Service 3"
              className="img-fluid rounded shadow mx-auto d-block"
            />
          </Col>
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital20).png"
              alt="Transport Service 4"
              className="img-fluid rounded shadow mx-auto d-block"
              width="212"
              height="400"
            />
          </Col>
        </Row> */}
      </Container>
    </section>
  );
};

export default Imgsec3;
